let ssIndex = 0;

export const stripHTML = (str) => str && str.replace(/<\/?[^>]+(>|$)/g, "");

export const htmlDecode = (input) => {
	var doc = new DOMParser().parseFromString(input, "text/html");
	return doc.documentElement.textContent;
}

export const ellipsisShorten = (string, lengthLimit) => {
	if (string && string?.length && lengthLimit && string.length > lengthLimit) {
		const limit = string.substr(0, lengthLimit).lastIndexOf(" ");
		return string.substr(0, limit) + "...";
	} else {
		return string;
	}
};

export const Ss7Domain = (ss7DomainsVal) => {
	const defaultUrl = "https://ss7.vzw.com/is/image/";
	const ss7Domains = ss7DomainsVal?.split(",") || [];
	const url = ss7Domains[ssIndex];
	if (ssIndex >= ss7Domains?.length) {
		ssIndex = 0;
	} else {
		ssIndex = ssIndex + 1;
	}
	return url || defaultUrl;
};

export const Ss7DomainWithVerizonWireless = (ss7Domains) => {
	return `${Ss7Domain(ss7Domains)}VerizonWireless/`;
};

export const attachLPEvent = (callback = () => {}) => {
	if (window?.["lpTag"] && window?.lpTag?.events?.bind) {
		window?.["lpTag"].events.bind({
			eventName: "state",
			appName: "lpUnifiedWindow",
			func: (state) => {
				if (state.state === "init") {
					console.log("chat initiated");
					if (callback) {
						callback();
					}
				}
			},
			context: window,
			async: false, //default is false,
			triggerOnce: false, //default is false
		});

		addEventForMobile();
	}
};

const addEventForMobile = (callback = () => {}) => {
	if (window?.["lpTag"]) {
		if (
			window?.["lpTag"] &&
			!window?.["lpTag"].unifiedwin?.DeviceDetector().isDesktop()
		) {
			// if(callback){
			//   callback();
			// }
		}
	}
};

export function downloadScript(url, id) {
	const scriptElem = document.createElement("script");
	scriptElem.type = "text/javascript";
	scriptElem.defer = true;
	scriptElem.src = url;
	scriptElem.onload = () => {
		const mktoForms2 = window["MktoForms2"];
		mktoForms2.loadForm("//info.verizonwireless.com", "324-BZD-350", id);
	};
	document.body.appendChild(scriptElem);
}

export const pickAs = (obj, props) =>
	Object.entries(obj).reduce((r, [k, v]) => {
		if (k in props) r[props[k]] = v;

		return r;
	}, {});

export const formatPriceString = (price, trimTrailingZeroes = false) => {
	if (price !== 0 && !price) {
		return "-";
	}
	if (typeof price === "string") {
		price = price.replace(/[$]+/g, "");
	}
	price = Number(price)?.toFixed(2);
	let ret = `$${getPriceWithComma(price)}`;
	if (trimTrailingZeroes) ret = ret.replace(".00", "");
	return ret;
};

export const getPriceWithComma = (priceN)=>{
	const dotValues = String(priceN).split('.')
	  const price = Number(dotValues[0])
	  const finalDot = (dotValues.length > 1 && dotValues[1].length > 1) ? ('.'+String(dotValues[1]).slice(0,2)): '.00'
	  return (price.toLocaleString()+finalDot)
}

export const isValidEmail = (val) => {
	if (!val?.trim()) {
		return false;
	} else {
		const pattern =
			/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return pattern.test(val);
	}
};

export const phoneNumberFormat = (val) => {
       return val ? val?.replace(/(\d{3})(\d{3})(\d{4})/, "$1.$2.$3") : "";
}


export const addScrollView = (name)=>{
	const business = document.getElementsByClassName(name)
		if(business!==null&&business&&business.length){
			setTimeout(()=>{
				business[0].scrollIntoView()
			setTimeout(()=>window.scrollBy(0,-160),500)
			},500)
		}
}
export const getFullRatingWidth = (rating) => {
	const size = Math.round(20 * rating);
	return size + "px";
};

export const getProductType = (category) =>
	category === "Smart Watches" ||
	category === "Connected Smartwatches" ||
	location?.pathname?.includes("smart-watches") ||
	String(category).toLowerCase().includes("smartwatch")
	  ? "smart-watches"
	  : category === "Phones" || location?.pathname?.includes("basic-phones")
	  ? "basic-phones"
	  : category === "BroadbandAccess Devices" ||
		location?.pathname?.includes("mobile-hotspots")
	  ? "mobile-hotspots"
	  : category === "Tablets" || location?.pathname?.includes("tablets")
	  ? "tablets"
	  : category === "Connected Laptops" ||
		location?.pathname?.includes("laptops")
	  ? "laptops"
	  : category === "Connected Devices" ||
		location?.pathname?.includes("desk-conference-phones")
	  ? "desk-conference-phones"
	  : "smartphones";
  /* sets a cookie in current domain */
export function setLocalCookie(
	cookieName,
	cookieValue,
	expiryDays = 5,
	secureOnly = true
) {
	const date = new Date();
	date.setTime(date.getTime() + expiryDays * 1000 * 60 * 60 * 24);
	let cookieStr =
		cookieName +
		"=" +
		cookieValue +
		"; expires=" +
		date.toUTCString() +
		(secureOnly ? ";secure" : "");
	const rootDomain = getDomainTLD(window.location.hostname);
	cookieStr = cookieStr + ";domain=" + rootDomain + ";path=/";
	document.cookie = cookieStr;
}

function getDomainTLD(domain) {
	if (undefined === domain || typeof domain != "string") {
		return null;
	}
	try {
		var domainParts = domain.split(".");
		var domainTLD =
			domainParts.length > 1
				? domainParts[domainParts.length - 2] +
				  "." +
				  domainParts[domainParts.length - 1]
				: domain;
		return domainTLD ? domainTLD : null;
	} catch (error) {
		return error;
	}
}

export const checkIfAemExists = (val)=>{
	if(typeof val == "boolean") return val
	return false
  }
  
export const loadChatScript = ()=>{
	const scriptElem = document.createElement("script");
	scriptElem.type = "text/javascript";
	scriptElem.defer = true;
	scriptElem.src = process.env.PROSPECT_WIDGETS_CHAT_URL;
	document.body.appendChild(scriptElem)
}

export const formatPhoneNumber = (phoneNumberString) => {
	const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
	const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
	if (match) {
	  return `${match[1]}.${match[2]}.${match[3]}`;
	}
	return null;
  }
  
  export const formatPhoneNumberWithSeperator = (phoneNumberString, seperator) => {
	const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
	const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
	let s = seperator ? seperator : "."
	if (match) {
	  return `${match[1]}${seperator}${match[2]}${seperator}${match[3]}`;
	}
	return null;
  }
  
export const exportTableToExcel =(tableID, filename = '') =>{
	const table = document.getElementById(tableID);
	 // Hide the "Age" column (index 1)
	  for (let row of table.rows)
	  {  row?.cells?.[2] && (row.cells[2].style.display='none');
		row?.cells?.[3] &&	(row.cells[3].style.display='none');
		row?.cells?.[4] && (row.cells[4].style.display='none'); 
	  }
		 let csvContent = ''; 
		 for (let row of table.rows) {
			 if (row.style.display !== 'none') { 
				// Only include visible cells
				 const rowData = Array.from(row.cells).filter((cell, index) => cell.style.display !== 'none').map(cell => cell.innerText).join(','); csvContent += rowData + '\n'; 
				}
				 } // Create a blob and download the CSV file 
				  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
				   const link = document.createElement('a');
				    const url = URL.createObjectURL(blob); 
					link.setAttribute('href', url); 
					link.setAttribute('download', 'LQ_Addresses.csv');
					 link.style.display = 'none'; 
					 document.body.appendChild(link);
					  link.click(); 
					  document.body.removeChild(link); // Show the column again (optional) 
					  for (let row of table.rows) {
						row?.cells?.[2] && (row.cells[2].style.display='');
						row?.cells?.[3] && (row.cells[3].style.display='');
						row?.cells?.[4] &&  (row.cells[4].style.display='');  
						}

    // var downloadLink;
    // var dataType = 'application/vnd.ms-excel';
    // var tableSelect = document.getElementById(tableID);
    // var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');
    
    // // Specify file name
    // filename = filename?filename+'.xlsx':'excel_data.xlsx';
    
    // // Create download link element
    // downloadLink = document.createElement("a");
    
    // document.body.appendChild(downloadLink);
    
    // if(navigator.msSaveOrOpenBlob){
    //     var blob = new Blob(['\ufeff', tableHTML], {
    //         type: dataType
    //     });
    //     navigator.msSaveOrOpenBlob( blob, filename);
    // }else{
    //     // Create a link to the file
    //     downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
    
    //     // Setting the file name
    //     downloadLink.download = filename;
        
    //     //triggering the function
    //     downloadLink.click();
    // }
}
export function  triggerCartIdLPEvent(deviceCount, cartId) {
    if (window?.['lpTag']) {
        window?.['lpTag']?.sdes?.push({
        "type": "cart", //MANDATORY
        "total": 0, //TOTAL CART VALUE
        "numItems": deviceCount, //NUMBER OF ITEMS IN CART
        "products": [{ //ARRAY OF PRODUCTS
          "product": {
            "name": "CartID", //PRODUCT NAME
            "category": "Business Shop", //PRODU(CT CATEGORY NAME
            "sku": cartId, //PRODUCT SKU OR UNIQUE IDENTIFIER
            "price": 0 //PRODUCT PRICE
          }
        }]
      });
    }
  }

export const getPayloadForAllFlowBYOR = ({flow,storedImeiInfo = [],planId="",operationVal="ADD",groupId="",isFwaBundleSelected, selectedBulkAddrKeys})=>{
	const payloadFor4G = []
	const payloadFor5G = []
	const templateForPaylaod = {
  
        "backUp": false,
        "packageId": "",
        "packageType": "FOURG",
        "operation": "",
        "plan": {
            "planId": ""
        },
        "groupId": "",
        "isFwaBundleSelected":false,
        "quantity": 1,
        "byor": true,
        "device": {
            "deviceSku": "",
            "deviceCategory": "",
            "deviceType": "FOURGROUTER",
            "quantity": 1,
            "byod": true,
      },
      "bulkAddresses":[
        {
            "operation": "UPDATE",
            "addressKeys": selectedBulkAddrKeys
        },
    ]
    }
		storedImeiInfo.map(item=>{
			if(String(item.flow).toUpperCase() === '5G'){
				payloadFor5G.push({...templateForPaylaod,planId:planId,packageType:'FIVEG',operation:operationVal,groupId:groupId,isFwaBundleSelected:isFwaBundleSelected,
					plan:{...templateForPaylaod.plan,planId:planId, planCategoryType: "CBAND"},
					device : {...templateForPaylaod.device,
						deviceType:"FIVEGROUTER",
						deviceSku: item?.deviceInfo?.deviceSkuId,
						"byodInfo": {
							imei: item?.deviceInfo?.imei,
							name: item?.deviceInfo?.name,
							psimCapable: item?.deviceInfo?.psimCapable,
							esimCapable: item?.deviceInfo?.esimCapable,
							newSim: (item?.deviceInfo?.simNumber || item?.simNumber) ? false :true, 
							skipImei: item?.deviceInfo?.imei ? false: true,
							simSku: item?.deviceInfo?.psimSku ?? item?.deviceInfo?.simSku,
							simNumber: item?.deviceInfo?.simNumber ?? item?.simNumber
						}
					},
				})
			}else{
				payloadFor4G.push({...templateForPaylaod,
					plan:{...templateForPaylaod.plan,planId:planId},operation:operationVal,groupId:groupId,isFwaBundleSelected:isFwaBundleSelected,
					device : {...templateForPaylaod.device,
						deviceSku: item?.deviceInfo?.deviceSkuId,
						"byodInfo": {
							imei: item?.deviceInfo?.imei,
							name: item?.deviceInfo?.name,
							psimCapable: item?.deviceInfo?.psimCapable,
							esimCapable: item?.deviceInfo?.esimCapable,
							newSim: (item?.deviceInfo?.simNumber ||item?.simNumber) ? false:true, 
							skipImei: item?.deviceInfo?.imei ? false: true,
							simSku: item?.deviceInfo?.psimSku ?? item?.deviceInfo?.simSku,
							simNumber: item?.deviceInfo?.simNumber ?? item?.simNumber
						}
					},
				})
			}
		})
		return {payloadFor4G,payloadFor5G}
}

export const scrollIdIntoView = (elementId, delay = 0) => {
	const element = document.getElementById(elementId);
	if(element){
	setTimeout(() => {
	  element.scrollIntoView({ behavior: "smooth" });
	}, delay);
}
  };
  
  export const scrollElementIntoView = ({
	element,
	offset = 0,
	behavior = "smooth",
	delay = 0,
  }) => {
	if (element) {
	  setTimeout(() => {
		const elementPosition = element?.getBoundingClientRect().top;
		window.scrollTo({
		  top: elementPosition + window.scrollY - offset,
		  behavior: behavior,
		});
	  }, delay);
	}
  };
  
  export const scrollIdIntoViewWithOffset = ({
	elementId,
	offset = 0,
	behavior = "smooth",
	delay = 0,  // delay in ms
  }) => {
	const element = document.getElementById(elementId);
	if (element)
	  scrollElementIntoView({
		element,
		offset,
		behavior,
		delay,
	  });
  };
  